import { createContext, useContext } from "react";
import { ExportConfiguration } from "frontend/canvas-controls/export-canvas/export-dialog";
import { CursorType } from "frontend/canvas-designer-new/cursor-type";

export const HeaderContext = createContext<{
  onExport: (withWatermark: boolean, config: ExportConfiguration) => void;
  onUpgrade: () => void;
  setCreatingTemplate: () => void;
  onPresentClicked: () => void;
  setVotingOpen: (open: boolean) => void;
  onClickVideoCall: () => void;
  setCursorType: (cursorType: CursorType) => void;
  onClickVideoCallHangUp: () => void;
}>({
  onExport: () => {},
  onUpgrade: () => {},
  setCreatingTemplate: () => {},
  onPresentClicked: () => {},
  setVotingOpen: () => {},
  onClickVideoCall: () => {},
  setCursorType: () => {},
  onClickVideoCallHangUp: () => {},
});

export const HeaderProvider = ({
  children,
  onExport,
  onUpgrade,
  setCreatingTemplate,
  onPresentClicked,
  setVotingOpen,
  onClickVideoCall,
  setCursorType,
  onClickVideoCallHangUp,
}: {
  children: React.ReactNode;
  onExport: (withWatermark: boolean, config: ExportConfiguration) => void;
  onUpgrade: () => void;
  setCreatingTemplate: () => void;
  onPresentClicked: () => void;
  setVotingOpen: (open: boolean) => void;
  onClickVideoCall: () => void;
  setCursorType: (cursorType: CursorType) => void;
  onClickVideoCallHangUp: () => void;
}) => {
  return (
    <HeaderContext.Provider
      value={{
        onExport,
        onUpgrade,
        setCreatingTemplate,
        onPresentClicked,
        setVotingOpen,
        onClickVideoCall,
        setCursorType,
        onClickVideoCallHangUp,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error("useHeaderContext must be used within an HeaderProvider");
  }
  return context;
};
